module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../node_modules/happypack/loader.js?id=jsx!./ProductDetailView.js"));
	}, "productDetailView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=productDetailView!./src/pages/ProductDetail/ProductDetailView.js
// module id = ./node_modules/bundle-loader/index.js?lazy&name=productDetailView!./src/pages/ProductDetail/ProductDetailView.js
// module chunks = 43